import React from 'react';

import { Page } from '../../../../../shared/ui/Page';
import { PaymentSettingsContainer } from '../containers/PaymentSettingsContainer';

export const PaymentSystemsPage = () => {
    return (
        <Page isBackButton title='Выбор платежной системы'>
            <PaymentSettingsContainer />
        </Page>
    );
};
